// Mock data for ApprentCal Testing & Calibration Laboratory

export const companyInfo = {
  name: "ApprentCal Testing & Calibration Laboratory",
  owner: "Mr Amit Kumar",
  phone: "8873395295",
  whatsapp: "+91 8440922761",
  email: "apprentcal@gmail.com",
  address: {
    line1: "H-10, Itarhi Road, Buxar, Bairi",
    city: "Buxar",
    state: "Bihar",
    pincode: "802123",
    country: "India"
  },
  hours: "Monday - Saturday: 9:00 AM - 6:00 PM",
  rating: 5.0,
  reviewCount: 2,
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3601.5!2d84.0!3d25.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDMwJzAwLjAiTiA4NMKwMDAnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const services = [
  {
    id: 1,
    category: "Electrical Testing Services",
    icon: "Zap",
    items: [
      "Transformer Testing (Power & Distribution)",
      "CT/PT Testing & Calibration",
      "Circuit Breaker Testing & Analysis",
      "Relay Testing & Coordination Studies",
      "Motor Testing (AC/DC Motors)",
      "Generator Testing & Load Bank Testing",
      "High Voltage Testing (Up to 80kV DC / 70kV AC)",
      "Insulation Resistance Testing",
      "Earth Resistance Testing",
      "Lightning Arrestor & Surge Protection Testing",
      "Cable Testing (HT/LT Cables)",
      "Capacitor Bank Testing"
    ]
  },
  {
    id: 2,
    category: "Calibration Services",
    icon: "Settings",
    items: [
      "Digital & Analog Multimeter Calibration",
      "Clamp Meter Calibration",
      "Energy Meter Calibration (Single & Three Phase)",
      "Power Analyzer Calibration",
      "Oscilloscope Calibration",
      "Insulation Tester Calibration (Megger)",
      "Earth Tester Calibration",
      "Current Transformer (CT) Calibration",
      "Potential Transformer (PT) Calibration",
      "Frequency Meter Calibration",
      "Temperature Instruments Calibration",
      "Pressure Gauge Calibration"
    ]
  },
  {
    id: 3,
    category: "Installation & Commissioning",
    icon: "Wrench",
    items: [
      "Electrical Panel Installation",
      "Relay Panel Installation & Setup",
      "SCADA & Automation Systems",
      "PLC & HMI Programming",
      "VFD Installation & Configuration",
      "Lightning Protection Systems",
      "Earthing System Design & Installation",
      "Power Factor Correction Systems",
      "Energy Management Systems",
      "Substation Equipment Installation"
    ]
  },
  {
    id: 4,
    category: "Safety & Compliance Testing",
    icon: "Shield",
    items: [
      "Electrical Safety Audits",
      "Load Flow & Short Circuit Studies",
      "Harmonic Analysis",
      "Arc Flash Study & Analysis",
      "Relay Coordination Studies",
      "Energy Auditing",
      "Thermography Testing",
      "Protective Device Testing",
      "Annual Maintenance Contracts (AMC)",
      "Preventive Maintenance Programs"
    ]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Bihar Power Distribution Ltd.",
    rating: 5,
    date: "2 months ago",
    text: "Excellent service for transformer testing and relay calibration. The team is highly professional and uses advanced equipment. Their reports are detailed and comply with all industry standards. Highly recommended!"
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Sunrise Industries",
    rating: 5,
    date: "3 months ago",
    text: "Very satisfied with their calibration services. They calibrated all our electrical instruments with precision and provided NABL traceable certificates. The turnaround time was quick and pricing was reasonable."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1767042286080-446afa2c78d8",
    title: "Precision Electrical Meters",
    description: "High accuracy analog measurement instruments"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1758295746012-41650245a9bb",
    title: "Digital Multimeter Testing",
    description: "Advanced digital testing equipment"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1767042286381-9587c6a7322a",
    title: "Calibration Instruments",
    description: "Professional calibration devices"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1723549645118-ab09243a01d3",
    title: "Signal Generator Controls",
    description: "Precision testing and calibration panels"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1621638363255-9c092fa8d4ab",
    title: "Electronic Oscilloscope",
    description: "Modern electronic testing equipment"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1580063665860-af92a61c2810",
    title: "Laboratory Equipment",
    description: "Professional oscillograph instruments"
  }
];

export const aboutContent = {
  mission: "To provide accurate, reliable, and compliant electrical testing and calibration services that ensure the safety and efficiency of electrical systems across industries.",
  vision: "To be the most trusted name in electrical testing and calibration services in Bihar and Eastern India, setting benchmarks for quality and precision.",
  values: [
    "Precision and Accuracy in every test",
    "Compliance with International Standards",
    "Timely Service Delivery",
    "Customer Satisfaction",
    "Continuous Technical Excellence"
  ],
  certifications: [
    "ISO 9001:2015 Certified",
    "NABL Accredited Laboratory",
    "Trained Technical Staff",
    "Calibrated Test Equipment"
  ]
};

export const stats = [
  { label: "Years of Experience", value: "10+" },
  { label: "Happy Clients", value: "500+" },
  { label: "Tests Completed", value: "5000+" },
  { label: "Expert Rating", value: "5.0" }
];